export const PROJECT_DSN = 'https://1765a2962f414fc7ac338d0dc962e646@o49094.ingest.sentry.io/5266098'
export const SHOULD_SEND_EVENT_PERCENTAGE = 1
